import type { LegalDoc } from './types';

export const supportDoc: LegalDoc = {
  slug: 'support',
  title: 'Support',
  effectiveDate: '2026-06-15',
  lastUpdated: '2026-06-15',
  intro:
    `Welcome to Sansara Support. We are here to help you get the most out of Sansara — an educational and factual market-information and portfolio-tracking app. This page explains how to reach us, what to expect, and answers the questions we are asked most often.`,
  sections: [
    {
      heading: 'How to Contact Us',
      paragraphs: [
        `The fastest way to reach us is by email. Please write from your registered email address and include your registered mobile number and a clear description of the issue so we can help you quickly.`,
      ],
      bullets: [
        `General support: support@sansarafin.com`,
        `Privacy and grievances: grievance@sansarafin.com`,
        `Postal address: Sansara, Kanpur, Uttar Pradesh, India`,
        `Support hours: Monday to Friday, 10:00 to 18:00 IST (excluding public holidays)`,
      ],
    },
    {
      heading: 'Response Times',
      paragraphs: [
        `We aim to respond to support emails within one (1) to two (2) business days. For formal grievances, our Grievance Officer acknowledges within twenty-four (24) hours and resolves within fifteen (15) days, in line with our Grievance Redressal Policy and the IT Rules, 2021.`,
      ],
    },
    {
      heading: 'Account and Login Help',
      paragraphs: [
        `Sansara uses one-time password (OTP) login. If you do not receive your OTP, check your network and spam folder, wait a moment and request a new code. We will never ask you for your broker, bank or exchange password, PIN or two-factor codes — please never share these with anyone claiming to be from Sansara. If you suspect unauthorised access to your account, contact support@sansarafin.com immediately.`,
      ],
    },
    {
      heading: 'Linking Your Zerodha Account',
      paragraphs: [
        `Linking your Zerodha account is optional and is done through Zerodha's official Kite Connect login. Sansara receives only the connection token and the holdings data you consent to share; we never see your Zerodha password or PIN. If linking fails, ensure your Zerodha credentials are active with Zerodha and try again. Any order you place is reviewed and confirmed by you on your own broker account.`,
      ],
    },
    {
      heading: 'Subscriptions and Billing',
      paragraphs: [
        `You can view your plan, upgrade, downgrade or cancel from Settings. Payments are processed by Razorpay. For refunds, please see our Refund and Cancellation Policy — annual plans have a seven-day cooling-off window, and monthly plans are not refundable on a pro-rata basis. For billing questions, email support@sansarafin.com with your transaction reference.`,
      ],
    },
    {
      heading: 'Managing Your Data and Privacy',
      paragraphs: [
        `You can access, correct or update your information from Settings, or by contacting our Grievance Officer. To learn how we handle your data and the rights you have under the Digital Personal Data Protection Act, 2023, please read our Privacy Policy.`,
      ],
    },
    {
      heading: 'Deleting Your Account',
      paragraphs: [
        `You can delete your account at any time from Settings > Account > Delete Account within the app, or by visiting https://sansarafin.com/delete-account on the web. Deletion removes your personal data within a reasonable period, subject to records we must retain by law. See our Delete Account guide for the full process.`,
      ],
    },
    {
      heading: 'A Note on What Sansara Does',
      paragraphs: [
        `Sansara provides factual market data, screeners, manual portfolio tracking and financial education. Sansara is not a SEBI-registered Research Analyst or Investment Adviser, and we cannot tell you what to buy, sell or hold, or give personalised investment advice. For advice tailored to your situation, please consult a SEBI-registered investment adviser. Our support team can help with the app, your account, billing and your data — but not with investment recommendations.`,
      ],
    },
    {
      heading: 'Reporting a Problem or Bug',
      paragraphs: [
        `If something is not working, email support@sansarafin.com with your device model, operating system version, app version and, if possible, a screenshot and the steps to reproduce the issue. This helps us diagnose and fix problems faster.`,
      ],
    },
  ],
};
